import React, { Suspense, ComponentType } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { ErrorPlaceholder } from './ErrorPlaceholder';

export function withErrorBoundary<P extends object>(
  Component: ComponentType<P>,
  errorFallback?: React.ReactNode
) {
  const WithErrorBoundary = (props: P) => {
    return (
      <ErrorBoundary fallback={errorFallback || <ErrorPlaceholder />}>
        <Suspense fallback={null}>
          <Component {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };

  // Set display name for debugging purposes
  const displayName = Component.displayName || Component.name || 'Component';
  WithErrorBoundary.displayName = `withErrorBoundary(${displayName})`;

  return WithErrorBoundary;
}
